<template>
  <div class="layout">
    <div
      @dragenter.prevent="dragEnter"
      @dragleave.prevent="dragLeave"
      class="dragdrop"
      id="drop-zone"
    >
      <div class="drop-items" @drop.prevent="drop" @dragover.prevent></div>
      <div class="content" @drop.prevent="drop" @dragover.prevent>
        <div
          style="width: 100%"
          class="d-flex justify-center align-center mb68"
        >
          <div style="width: 100px; height: 100px">
            <v-img
              style="object-fit: contain"
              src="@/assets/images/upload/Image-drop-upload-ver2.png"
            ></v-img>
          </div>
        </div>
        <div
          class="message hidden-sm-and-down mb-3"
          @drop.prevent="drop"
          @dragover.prevent
        >
          วางไฟล์ไว้ที่ใดก็ได้ เพื่ออัปโหลด
        </div>
        <div
          class="message hidden-sm-and-down"
          @drop.prevent="drop"
          @dragover.prevent
        >
          หรือ
        </div>
        <div class="message py-2" @drop.prevent="drop" @dragover.prevent>
          <div></div>
          <label class="custom-file-upload mb-3">
            <input
              multiple
              type="file"
              id="avatar"
              name="avatar"
              :accept="accept"
              @input="selectFile"
            />
            <i class="fa fa-cloud-upload"></i> เลือกไฟล์
          </label>
        </div>
        <div
          class="message hidden-sx-and-down description"
          @drop.prevent="drop"
          @dragover.prevent
        >
          <div>เลือกแล้ว {{ files.length }} ไฟล์</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid'

// Refs Drag Drop Counter https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
export default {
  data () {
    return {
      total: 0,
      success: 0,
      // files: [],

      dropElement: null,
      counter: 0
    }
  },
  props: {
    value: {
      type: null,
      default: () => []
    },
    accept: {
      type: String,
      default: ''
    }
  },
  mounted () {
    this.dropElement = document.getElementById('drop-zone')
  },
  computed: {
    files: {
      get () {
        return this.value
      },
      set (val) {
        let x = val

        // TODO FIX Validate type
        if (this.accept.length > 0) {
          const t = this.accept.split(',')
          x = val.filter((x) => {
            // TODO เป็น File ที่ check ได้จาก type
            if (t.indexOf(x.type) >= 0) return true
            else {
              // TODO ไม่สามารถเช็คจาก type ได้
              const tf = x.name.substr(x.name.lastIndexOf('.') + 1)
              if (t.indexOf(tf) >= 0 || t.indexOf(`.${tf}`) >= 0) return true
              else return false
            }
          })
        }
        this.$emit('input', x)
        return x
      }
    }
  },
  methods: {
    drop (e) {
      const items = e.dataTransfer.items
      for (const item of items) {
        if (item.kind === 'file') {
          const entry = item.webkitGetAsEntry()
          if (entry.isDirectory) {
            this.handleDirectory(entry)
          } else {
            const file = item.getAsFile()
            this.handleFile(file)
          }
        }
      }

      this.$nextTick(() => {
        this.counter = 0
        document.getElementById('drop-zone').classList.remove('dragging')
      })
    },

    handleDirectory (directoryEntry) {
      const reader = directoryEntry.createReader()
      reader.readEntries((entries) => {
        entries.forEach((entry) => {
          if (entry.isFile) {
            entry.file((file) => {
              this.handleFile(file)
            })
          } else if (entry.isDirectory) {
            // Recursive call for subdirectories
            this.handleDirectory(entry)
          }
        })
      })
    },

    handleFile (file) {
      if (
        file.type.startsWith('image/png') ||
        file.type.startsWith('image/jpeg') ||
        file.name.toLowerCase().endsWith('.dcm') ||
        file.name.endsWith('.jpg')
      ) {
        file.id = uuid.v4()
        this.files.push(file)
        this.files = Array.from(this.files)
      }
    },

    // dragOver () {
    //   console.log('dragOver')
    // },
    dragEnter (e) {
      this.counter++
      document.getElementById('drop-zone').classList.add('dragging')
      // e.target.classList.add('dragging')
    },
    dragLeave (e) {
      this.counter--
      if (this.counter === 0) {
        document.getElementById('drop-zone').classList.remove('dragging')
      }
      // e.target.classList.remove('dragging')
    },
    // selectFile (e) {
    //   for (let i = 0; i < e.target.files.length; i++) {
    //     e.target.files[i].id = uuid.v4()
    //   }
    //   this.files = Array.from(this.files).concat(Array.from(e.target.files))
    //   // this.files = e.target.files
    // },
    async selectFile (e) {
      // console.log(e)
      for (let i = 0; i < e.target.files.length; i++) {
        e.target.files[i].id = uuid.v4()
      }
      // this.files = e.target.files
      // console.log('selectedFile')
      // console.log(this.files)
      // const ctScanArr = []
      // const xRayArr = []
      const dcmArr = []
      // const xRay = ['CR', 'DX', 'OT']
      // const ctScan = ['CT']
      const dcm = ['CR', 'DX', 'OT', 'CT']

      try {
        // NOTE CHECK Modality เครื่อง Xray
        const getMeta = await this.getMetaData(e.target.files)
        for (let i = 0; i < getMeta.length; i++) {
          const meta = getMeta[i]

          if (!getMeta || !meta || !meta.Modality || !meta.Modality.value) {
            throw new Error('ไฟล์ที่ไม่รองรับหรือไม่มีข้อมูล')
          }

          const Modality = meta.Modality.value[0]
          // NOTE CHECK DICOM ONLY
          if (dcm.includes(Modality)) {
            dcmArr.push(e.target.files[i])
          }
          // NOTE CHECK CT-Scan And X-Ray
          // if (ctScan.includes(Modality)) {
          //   ctScanArr.push(e.target.files[i])
          // } else if (xRay.includes(Modality)) {
          //   xRayArr.push(e.target.files[i])
          // }
        }
        this.files = Array.from(this.files).concat(Array.from(e.target.files))
        // NOTE return แยก xRay และ ctScan
        // return { xRayArr, ctScanArr }
        return dcmArr
      } catch (error) {
        // NOTE ถ้า ไฟล์ ไม่ใช่ ชนิด Dicom
        console.error(error.message, e.target.files)
        // this.$swal.fire({
        //   icon: 'error',
        //   title: 'ไฟล์ที่ไม่รองรับ',
        //   text: 'ไฟล์นี้ไม่รองรับและไม่สามารถอัปโหลดได้'
        // })
        // return { dcmArr: [] }
        this.files = Array.from(this.files).concat(Array.from(e.target.files))
      }
    },
    clear () {
      this.files = []
    }
  }
}
</script>

<style lang="css" scoped>
.layout {
  height: calc(100% - 2px);
  /* width: 100%; */
  width: 100%;
  /* padding: 16px; */
  border-style: dashed;
  border-color: var(--v-primary-base);
  border-width: 2px;
  /* border-radius: 5px; */
  border-radius: 20px;

  position: relative;
}

.dragging {
  background: #dddddd !important;
}

.dragdrop {
  /* width: 100%; */
  width: 100%;
  height: 450px;
  /* position: relative; */
  border-radius: 20px;
  background: #f8fafd;
  /* background: lightpink; */
}
.dragdrop .drop-items {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}

.dragdrop .content {
  position: absolute;
  /* background: red; */
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content .message {
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--v-primary-base);
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.content .message.description {
  font-size: 0.9rem;
  font-weight: 200;
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid inherit;
  border-radius: 20px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  background: var(--v-primary-base);
  color: #fff;
  /* color: blue; */
}

.custom-file-upload:hover {
  background: var(--v-primary-lighten1);
}
</style>
